import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import { HashRouter as Router, Redirect, Route } from 'react-router-dom';
import { Account } from '@websky/core';
import { ThemeProvider } from '@websky/core/src/theme';

import accountTheme from '../../theme/accountTheme';
import '../../theme/variables.css';
import Head from '@websky/core/src/Head';
import CarouselStyles from '@websky/core/src/CarouselStyles/CarouselStyles';

const AccountComponent: React.FC = () => {
	return (
		<Router>
			<ThemeProvider value={accountTheme}>
				<Head>
					<CarouselStyles />
				</Head>
				<Route exact path="/" render={() => <Redirect to="/account" />} />
				<Account />
			</ThemeProvider>
		</Router>
	);
};

export default AccountComponent;
